import { render } from "./rough_to_polish.vue?vue&type=template&id=6ab5ff10&scoped=true"
import script from "./rough_to_polish.vue?vue&type=script&lang=js"
export * from "./rough_to_polish.vue?vue&type=script&lang=js"

import "./rough_to_polish.vue?vue&type=style&index=0&id=6ab5ff10&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab5ff10"]])

export default __exports__